import { z } from 'zod';

export const DriverGroupSchema = z.object({
  driverGroupId: z.number().min(0),
  driverGroupName: z.string().min(1),
  numberOfDrivers: z.number().optional(),
});

export const driverGroupsSchema = z.array(DriverGroupSchema);

export type DriverGroup = z.infer<typeof DriverGroupSchema>;
